api = require('../0_def.coffee')

api.factory 'api/Provider#factory', [
  'ksc.EditableRecord', 'ksc.RestList',
  (EditableRecord, RestList) ->
    contract =
      providerId: { type: 'number' }
      providerGuid: { type: 'string', nullable: true }
      practiceId: { type: 'number' }
      userId: { type: 'number' }
      enterpriseSiteUserId: { type: 'number', nullable: true }
      firstName: { type: 'string' }
      lastName: { type: 'string' }
      practiceUserActive: { type: 'boolean' }
      practiceUserProvider: { type: 'boolean' }
      practiceUserHidden: { type: 'boolean' }
      createdAt: { type: 'number', nullable: true }
      updatedAt: { type: 'number', nullable: true }
      createdBy: { default: -1 }
      updatedBy: { default: -1 }

    class Provider extends EditableRecord
      _name: =>
        @lastName + ', ' + @firstName


    ->
      new RestList
        cache: true
        endpoint:
          url: '/dashboard-calendar-ui/api/Provider'
        record:
          class: Provider
          contract: contract
          idProperty: 'providerId'
          url: '/dashboard-calendar-ui/api/Provider/<id>'
]


api.service 'api/Provider', [
  'api/Provider#factory',
  (providersFactory) ->
    service = providersFactory()

    # entire response can be cached, no partial loads. Load right away.
    service.restLoad { deleted: false }

    service
]
